import Page from '../page';

import { gradient } from "./gradient";
//import { gradientNew } from "../../lib/gradientNew";
import { thum } from "./thum";
import { select } from "./select";
import { news } from "./news";
import { inview } from '../../lib/inview';

export default class TopManager extends Page {
	constructor() {
		super();
	}
	init() {
		gradient(this);
		//gradientNew(this);
		thum(this);
		select(this);
		news(this);

		this.scroll();
		this.resize();
		window.dispatchEvent(new Event('resize'));
		
		
		setTimeout(showNav1, 900);
		setTimeout(showNav2, 300);
		setTimeout(showNavShowed, 1600);
		

		

		function showNav1(){
			document.getElementById("navMainList").classList.add("show");
		}
		function showNav2(){
			document.getElementById("navSubList").classList.add("show");
		}
		function showNavShowed(){
			document.getElementById("topHeader").classList.add("showed");
		}

		setTimeout(showBarColorChange, 1200);
		setTimeout(showBar01, 900);
		setTimeout(showBar02, 1200);
		setTimeout(showBar03, 800);
		setTimeout(showBar04, 1600);
		setTimeout(showBar05, 900);
		setTimeout(showBar06, 1100);
		setTimeout(showBar07, 800);
		setTimeout(showBar08, 1200);

		function showBarColorChange(){
			var bar = document.getElementsByClassName("bar");
			for(var i = 0; i < bar.length; i++){
				bar[i].className += " change";
			}
		}		
		function showBar01(){
			document.getElementById("bar01").classList.add("show");
		}
		function showBar02(){
			document.getElementById("bar02").classList.add("show");
		}
		function showBar03(){
			document.getElementById("bar03").classList.add("show");
		}
		function showBar04(){
			document.getElementById("bar04").classList.add("show");
		}
		function showBar05(){
			document.getElementById("bar05").classList.add("show");
		}
		function showBar06(){
			document.getElementById("bar06").classList.add("show");
		}
		function showBar07(){
			document.getElementById("bar07").classList.add("show");
		}
		function showBar08(){
			document.getElementById("bar08").classList.add("show");
		}


		setTimeout(bgAnime01, 300);
		setTimeout(bgAnime02, 600);
		setTimeout(bgAnime03, 500);
		setTimeout(bgAnime04, 800);

		function bgAnime01(){
			document.getElementById("bgAnime01").classList.add("show");
		}
		function bgAnime02(){
			document.getElementById("bgAnime02").classList.add("show");
		}
		function bgAnime03(){
			document.getElementById("bgAnime03").classList.add("show");
		}
		function bgAnime04(){
			document.getElementById("bgAnime04").classList.add("show");
		}

		setTimeout(topAddress, 800);

		function topAddress(){
			document.getElementById("topAddress").classList.add("show");
		}





		inview([
			document.getElementById('bgAnime05'),
			document.getElementById('bgAnime06'),
			document.getElementById('bgAnime07'),
		], (direction, el) => {
			if (direction == 'down') {
				el.classList.add('show')
			}
		});


		const topAddressEl = document.querySelector(".topHeader address");

		inview(document.getElementById('wroks'), (direction) => {
			topAddressEl.classList.toggle('hide', direction == 'down');
		}, '120%');



	}
	scroll() {
		// 以前は scroll イベントのたびに gsap.to を 8 個作っていた。
		// 係数は以前と同じ（#bgAnime02 は 0.3 と 0.1 が二重指定で、後の 0.1 が効いていた）
		const parallax = [
			['bgAnime01', 0.1],
			['bgAnime02', 0.1],
			['bgAnime03', 0.2],
			['bgAnime04', 0.05],
			['bgAnime05', 0.1],
			['bgAnime06', -0.05],
			['bgAnime07', 0.3],
		].map(([id, rate]) => [document.getElementById(id), rate]).filter(([el]) => el);

		let ticking = false;

		const update = () => {
			ticking = false;
			parallax.forEach(([el, rate]) => {
				el.style.transform = `translate3d(0, ${this.winScrollTop * rate}px, 0)`;
			});
		};

		document.addEventListener('scroll', () => {
			if (!ticking) {
				ticking = true;
				requestAnimationFrame(update);
			}
		}, { passive: true });
	}
	resize() {
		window.addEventListener('resize', function (e) {

		})
	}
}